module.exports = __webpack_public_path__ + "static/media/6COPUOS3.1dbd31d8.jpg";